import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  });
}

// 验证 Token (包含密码指纹校验)
export function checkToken() {
  return request({
    url: '/user/checkToken',
    method: 'get'
  });
}

export function getUserList() {
  return request({
    url: '/user/query',
    method: 'get'
  });
}

export function addUser(data) {
  return request({
    url: '/user/addUser',
    method: 'post',
    data
  });
}